import { ComponentFactoryResolver, Inject, Injectable, Injector, LOCALE_ID } from "@angular/core";
import { LoadingService } from "@farris/ui-loading";
import { MessagerService } from "@farris/ui-messager";
import { BsModalService } from "@farris/ui-modal";
import { AppOptions, FrameworkService } from "@gsp-sys/rtf-common";
import { Observable, from, of } from "rxjs";
import { BpmRuntimeExecutionService, StartProcessPayload } from "@edp-bpm/universal-runtime-api";
import { switchMap } from "rxjs/operators";

@Injectable()
export class BpmRuntimeDevkitService {
    constructor(
        public bpmRuntimeExecutionService: BpmRuntimeExecutionService,
        public framework: FrameworkService,
        public messager: MessagerService,
        public loading: LoadingService,
        @Inject(LOCALE_ID) public localeId: string,
        public modalService: BsModalService,
        public cfr: ComponentFactoryResolver,
        public injector: Injector,
    ) { }

    /**
     * 启动业务流程
     * @param payload 业务流启动参数
     * @returns
     */
    startProcess(payload: StartProcessPayload): Observable<any> {
        return from(this.bpmRuntimeExecutionService.startProcess(payload)).pipe(
            switchMap((res) => {
                return of(res.data);
            })
        );
    }

    /**
     * 通过运行框架查看流程实例
     * @param procInstId 流程实例ID
     */
    viewProcessInstance(procInstId: string) {
        // 如果gspframeworkService为空则尝试使用frameworkService打开
        if (!(window as any).gspframeworkService || !(window as any).gspframeworkService.rtf || !(window as any).gspframeworkService.rtf.func) {
            const queryParams = {
                id: procInstId,
                operation: "View",
            };
            const map = new Map(Object.entries(queryParams));

            const opts = {
                funcId: BpmRuntimeExecutionService.bpmInstanceViewerFuncId,
                tabId: procInstId,
                appType: "menu",
                entityParams: queryParams,
                queryStringParams: map,
            };
            this.framework.openMenu(opts);
        } else {
            this.bpmRuntimeExecutionService.viewProcessInstance(procInstId);
        }
    }
}